import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Store } from "@ngxs/store";
import { Observable, of } from "rxjs";
import { UserState } from "../../store/user/user.store";
import { map } from "rxjs/operators";
import { HomeBannerService } from "src/app/shared/services/home-banner.service";

@Injectable({ providedIn: "root" })
export class LoggedGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
    private homeBannerService: HomeBannerService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<true | UrlTree> {
    // No token fallback
    this.homeBannerService.redirectUrl = state.url;
    return this.store
      .select(UserState.authToken)
      .pipe(
        map((authToken) =>
          authToken?.token ? true : this.router.parseUrl("/membership/login")
        )
      );
  }
}
